import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as currentStatusActions from 'modules/currentStatus';

import { Route, Switch } from 'react-router-dom';
import styled from 'styled-components';
//import { Sidebar, Segment, Header } from 'semantic-ui-react';

import {
  CtProfile,
  CtMyPageMenu,
  CtSmtpConf,
  CtEduConf,
  CtEduQuizConf,
  CtDeclareConf,
  CtExamTemplate,
  CtPhishingTemplate,
  CtLicense,
  CtRelease,
  CtServiceShare,
  CtAdminSmtpConf,
  CtAdminQna,
  CtAdminLicense
} from 'containers';

import { MaterialSnackbar } from 'components';

import { NotFoundPage } from 'pages';

const ScSection = styled.section`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const ScHeader = styled.header`
  height: 50px;
`;
const ScMain = styled.main`
  flex: 1;
  position: relative;
  display: flex;
  background-color: #f5f5f5;
  height: 100%;
`;
const ScPage = styled.div`
  // padding: 25px;
  // background-color: #fafafa;
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;
const ScFooter = styled.footer`
  height: 20px;
  display: none;
`;

class MyPage extends Component {
  componentDidMount() {
    const { CurrentStatusActions } = this.props;

    if (this.pageRef) {
      CurrentStatusActions.pageHeight(this.pageRef.clientHeight);
    }
  }
  // 성공 실패시 알림창
  onToggleSnackbar = message => {
    const { CurrentStatusActions } = this.props;
    setTimeout(() => {
      CurrentStatusActions.toggleSnackbar({ message: '' });
    }, 5000);

    CurrentStatusActions.toggleSnackbar({ message });
  };
  render() {
    const { serviceNo, originalServiceNo, match, location, history, isSnackbar } = this.props;

    const baseUrl = match.url;

    if (serviceNo !== originalServiceNo) {
      // 이 경우에는 본인 서비스에서만 이용 가능한 메뉴 요청시 404 발생하므로 / 로 가도록 처리한다.
      const activeLink = location.pathname.replace(match.url + '/', '');
      if (activeLink === 'profile' || activeLink === 'share' || activeLink === 'deactivate') {
        history.replace(match.url);
        return null;
      }
    }

    return (
      <ScSection>
        <ScMain>
          {/* <SplitPane
            split="vertical"
            defaultSize={250}
            minSize={150}
            maxSize={300}
            paneStyle={paneStyle}
            pane1Style={menuHideStyle}
            pane2Style={pane2Stype}> */}
          <CtMyPageMenu />
          <MaterialSnackbar isSnackbar={isSnackbar} onToggleSnackbar={this.onToggleSnackbar} />
          <div
            style={{
              width: '100%',
              height: '100%',
              overflowY: 'auto'
            }}
            ref={ref => (this.pageRef = ref)}>
            <Switch>
              <Route exact path={baseUrl} component={serviceNo === originalServiceNo ? CtProfile : CtSmtpConf} />
              {serviceNo === originalServiceNo && <Route exact path={baseUrl + '/profile'} render={() => <CtProfile serviceNo={serviceNo} />} />}
              <Route exact path={baseUrl + '/smtp'} component={CtSmtpConf} />
              <Route exact path={baseUrl + '/edu'} component={CtEduConf} />
              <Route exact path={baseUrl + '/edu/quiz'} component={CtEduQuizConf} />
              <Route exact path={baseUrl + '/declare'} component={CtDeclareConf} />
              <Route exact path={baseUrl + '/examtemplate'} component={CtExamTemplate} />
              <Route exact path={baseUrl + '/examtemplate/examtemplatePhishing'} component={CtPhishingTemplate} />
              <Route exact path={baseUrl + '/license'} component={CtLicense} />
              <Route exact path={baseUrl + '/release'} component={CtRelease} />
              <Route exact path={baseUrl + '/qna'} component={CtAdminQna} />
              {serviceNo === originalServiceNo && <Route exact path={baseUrl + '/share'} component={CtServiceShare} />}
              {serviceNo === originalServiceNo && (
                <Route exact path={baseUrl + '/deactivate'} component={CtAdminLicense} />
              )}
              <Route component={NotFoundPage} />
            </Switch>
          </div>
          {/* </SplitPane> */}
        </ScMain>
        <ScFooter>{/**/}</ScFooter>
      </ScSection>
    );
  }
}

MyPage.propTypes = {};
MyPage.defaultProps = {};

const mapStateToProps = state => ({
  serviceNo: state.user.get('user').serviceNo,
  originalServiceNo: state.user.get('user').originalServiceNo,
  isSnackbar: state.currentStatus.get('isSnackbar')
});

const mapDispatchToProps = dispatch => ({
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(MyPage);



// WEBPACK FOOTER //
// ./src/script/pages/MyPage.js